export const InsuranceEN = {
    "employeeInsurance": {
        "breadCrumb": {
            "insuranceIncrease": "Insurance increase list month",
            "insuranceDecrease": "Insurance decrease list month",
            "insurancePayment": "Insurance payment list month",
            "insuranceHistory": "Insurance auditing list month"
        },
        "title": {
            "generalInformation": "General information",
            "increaseMajor": "Increase major",
            "decreaseMajor": "Decrease major",
            "insurancePaymentHistories": "Insurance payment auditing",
            "regimeSolveHistories": "Regime solve auditing"
        },
        "label": {
            "socialInsuranceCode": "Social Insurance Code",
            "state": "State",
            "department": "Department",
            "healthInsuranceCode": "Health Insurance Code",
            "province": "Province",
            "healthFacility": "Health facility",
            "incEmployeeCompleteProfileDate": "EMP complete profile date",
            "incHumanResourceCompleteProfileDate": "HRM complete profile date",
            "incReceiveHealthInsuranceCardDate": "Receive ins card date",
            "incReturnHealthInsuranceCardDate": "Return ins card date",
            "decReceiveInsuranceBookDate": "Receive ins book date",
            "decHumanResourceCompleteProfileDate": "HRM complete profile date",
            "decReceiveClosedInsuranceBookDate": "Receive closed book date",
            "decReturnInsuranceBookDate": "Return ins book date",
            "confirmDate": "Confirm date",
            "fromMonth": "From month",
            "formality": "Formality",
            "increaseFormality": "Increase",
            "decreaseFormality": "Decrease",
            "reason": "Reason",
            "insuranceAmount": "Insurance Amount",
            "companyAmount": "Company Amount",
            "employeeAmount": "Employee Amount",
            "regimeType": "Regime Type",
            "receiveProfileDate": "Receive Profile Date",
            "procedureCompleteDate": "Pro Complete Date",
            "receiveInsuranceMoneyDate": "Receive ins money Date",
            "returnRegimeMoneyDate": "Return money Date",
            "regimeAmount": "Regime Amount",
            "count": "Number",
            "TT": "Num",
            "all": "All"
        },
        "placeHolder": {
            "socialInsuranceCode": "Code",
            "state": "Select State",
            "department": "Select Department",
            "healthInsuranceCode": "Code",
            "province": "Select Province",
            "healthFacility": "Select Health facility",
            "formality": "Select Formality",
            "reason": "Select Reason",
            "confirmDate": "Confirm date",
            "amount": "Amount",
            "companyAmount": "Company Amount",
            "regimeType": "Select Regime type"
        },
        "message": {
            "incCompleteDateException": "Employee complete profile date must before HRM complete profile date",
            "incReturnDateException": "Receive Health Ins date must before Return Health Ins Date",
            "decCompleteDateException": "Receive Ins book must before HRM complete profile date",
            "decReturnDateException": "Receive Ins close book must before Return Ins book date",
            "procedureCompleteDateException": "Receive profile date must before Procedure complete date",
            "receiveInsuranceMoneyDateException": "Procedure complete date must before Receive Ins money date",
            "returnRegimeMoneyDateException": "Procedure complete date must before Return regime money date",
            "add": "Add successful",
            "update": "Update successful",
            "error": "Error",
            "duplicateInsurancePaymentHistoryInMonth": "In 1 month there cannot be 2 increase or decrease payment auditing",
            "conflictInsurancePaymentHistoryInMonth": "Conflict over closing date of monthly up and down reports",
            "titleConfirm": "Confirm",
            "confirmContent": "Do you want to confirm insurance?",
            "titleCancelConfirm": "Cancel confirm",
            "cancelConfirmContent": "Do you want to cancel confirm insurance?",
            "confirm": "Confirm success",
            "cancelConfirm": "Cancel confirm success",
            "required": {
                "formality": "Please select Formality",
                "fromMonth": "Select month",
                "employeeInsuranceRate": "Please enter at least 1 type of insurance",
                "insuranceCompanyRate": "The insurance rate paid by the company cannot be greater than the general insurance rate",
                "duplicateInsuranceRate": "Can't have two insurance rates in the same month"
            }
        }
    },
    "insuranceSider": {
        "headingLabel": "Insurance",
        "listInsurancePayment": "Payment",
        "listInsuranceIncrease": "Increase",
        "listInsuranceDecrease": "Decrease",
        "listInsuranceHistory": "History"
    },
    "insuranceColumns": {
        "employeeCode": "Emp Code",
        "employeeName": "Emp Name",
        "department": "Department",
        "jobPosition": "Job Position",
        "jobTitle": "Job job-title",
        "socialInsuranceCode": "Health Ins Code",
        "healthInsuranceCode": "Social Ins Code",
        "fromMonth": "From month",
        "amount": "Amount",
        "companyAmount": "CMP Amount",
        "employeeAmount": "EMP Amount",
        "reason": "Reason",
        "confirm": "Confirm",
        "notConfirm": "Not confirm",
        "cancelConfirm": "Cancel confirm",
        "TT": "Num",
        "month": "Month",
        "obligateAmount": "Obl Amount",
        "payment": "Payment",
        "sum": "Sum"
    }
}
